import React from 'react';
import { MessageCircle } from 'lucide-react';
import { LoginForm } from '../../features/auth/components';
import { usePageTitle } from '../../hooks/usePageTitle';

export const LoginPage: React.FC = () => {
  usePageTitle('ログイン');
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: '20px',
        boxShadow: '0 4px 24px rgba(15,23,42,0.08)',
        padding: '40px',
        width: '100%',
      }}
    >
      {/* EntryBOT ロゴ + サブタイトル */}
      <div style={{ textAlign: 'center', marginBottom: '28px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '6px' }}>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 8,
              background: '#0a7a72',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <MessageCircle size={20} color="white" />
          </div>
          <span style={{ fontSize: '22px', fontWeight: 700, color: '#0F172A' }}>EntryBOT</span>
        </div>
        <p style={{ fontSize: '14px', color: '#64748B' }}>アカウントにログイン</p>
      </div>

      <LoginForm />
    </div>
  );
};
